export const SUPPORT_EMAIL = "support@optidev.ai";
export const SUPPORT_MAILTO_URL = `mailto:${SUPPORT_EMAIL}`;
